/* <surisa-product-gallery> — galería PDP: thumbs + imagen principal con
   flechas prev/next + "Ampliar". Las imágenes vienen del SSR (product.media);
   este componente solo gestiona la interacción del escaparate.

   El visor a pantalla completa NO vive aquí: es el componente compartido
   <surisa-image-lightbox> (Fix 9). Esta galería recoge sus slides y delega en
   él vía .open(images, idx); al cerrar, el lightbox llama onClose(idx) para
   dejar el escaparate sincronizado con la última imagen vista.

   Imagen por variante: cada slide lleva `data-media-id` (SSR) y el componente
   se suscribe a `PUB_SUB_EVENTS.variantChange`, que `product-info.js` ya
   publica en cada cambio de variante con el variant completo. Así no hay que
   tocar Dawn: su propio `updateMedia` está escrito contra <media-gallery> y
   no encuentra nada en este PDP (ver comentario de la galería en
   sections/main-product-pdp.liquid).

   NAVEGACIÓN FILTRADA — los slides marcados `data-variant-media` pertenecen a
   una variante concreta. Están TODOS en el DOM (es lo que permite saltar a la
   foto de la variante recién elegida sin recargar), pero sólo son navegables
   a mano las media LIBRES (fotos de contexto, planos) más la foto de la
   variante activa. Thumbs, flechas y lightbox trabajan sobre esa lista
   (`_navIndexes()`), no sobre todos los slides: así la tira nunca enseña las
   fotos de las otras variantes.

   Cuando no hay media libre, la lista queda en 1 item: el SSR ya no pinta ni
   thumbs ni flechas y el lightbox abre esa única imagen, de modo que no se
   puede navegar a la de otra variante y quedar desincronizado del desplegable. */
(function () {
  if (customElements.get('surisa-product-gallery')) return;

  customElements.define('surisa-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.idx = 0;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.pdp__thumb'));
      this.total = this.slides.length;
      this.lightbox = this.querySelector('surisa-image-lightbox');
      // Hover-preview solo en desktop con puntero fino (ratón); en táctil no
      // hay hover y el click sigue fijando la imagen.
      this.hoverCapable = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
      if (!this.total) return;

      // El SSR abre en la imagen de la variante seleccionada, no siempre en la
      // primera → arrancar `idx` en el slide que NO viene oculto.
      var visible = this.slides.findIndex(function (s) { return !s.hidden; });
      if (visible > -1) this.idx = visible;

      // mediaId → índice de slide, para resolver el salto por variante.
      this.byMediaId = {};
      this.slides.forEach(function (s, n) {
        var id = s.getAttribute('data-media-id');
        if (id) this.byMediaId[id] = n;
      }, this);

      // Media de la variante activa: la del slide inicial, si es de variante.
      var start = this.slides[this.idx];
      this.variantMediaId = start && start.hasAttribute('data-variant-media')
        ? start.getAttribute('data-media-id')
        : null;

      this._bind();
      this._bindVariantChange();
      this._syncThumbs();
    }

    // Slides navegables a mano: las media libres + la foto de la variante
    // activa. En orden de DOM (= orden de product.media).
    _navIndexes() {
      var vid = this.variantMediaId;
      var out = [];
      this.slides.forEach(function (s, n) {
        if (!s.hasAttribute('data-variant-media') || s.getAttribute('data-media-id') === vid) out.push(n);
      });
      return out;
    }

    // Destapa el thumb de la variante activa y tapa el de las demás. Los
    // thumbs de media libre nunca se tocan.
    _syncThumbs() {
      var vid = this.variantMediaId;
      this.thumbs.forEach(function (t) {
        if (!t.hasAttribute('data-variant-media')) return;
        t.hidden = t.getAttribute('data-media-id') !== vid;
      });
    }

    // Salta al slide cuya media coincide con la imagen destacada de la variante
    // recién seleccionada. Si esa variante no tiene imagen (o su media no está
    // en la galería) no se toca nada: mejor dejar la foto actual que vaciarla.
    showByMediaId(mediaId) {
      if (mediaId == null) return;
      var key = String(mediaId);
      var i = this.byMediaId[key];
      if (i === undefined) return;
      if (this.slides[i].hasAttribute('data-variant-media')) {
        this.variantMediaId = key;
        this._syncThumbs();
      }
      this.show(i);
    }

    _bindVariantChange() {
      // `subscribe` y `PUB_SUB_EVENTS` son globales de pubsub.js / constants.js,
      // cargados antes que este fichero en theme.liquid. Se comprueban de todas
      // formas: la galería debe seguir funcionando si algún día se usa en una
      // plantilla que no los cargue.
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      var self = this;
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.featured_media) self.showByMediaId(variant.featured_media.id);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribeVariant) this.unsubscribeVariant();
    }

    _bind() {
      var self = this;
      this.thumbs.forEach(function (t) {
        var i = parseInt(t.getAttribute('data-index'), 10);
        // Click = fija la imagen (persiste). Hover = previsualiza sin fijar.
        t.addEventListener('click', function () { self.show(i); });
        if (self.hoverCapable) t.addEventListener('mouseenter', function () { self._display(i); });
      });
      if (this.hoverCapable) {
        var thumbsWrap = this.querySelector('.pdp__thumbs');
        if (thumbsWrap) thumbsWrap.addEventListener('mouseleave', function () { self._display(self.idx); });
      }
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); self._step(-1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); self._step(1); });

      var stage = this.querySelector('[data-stage]');
      var zoom = this.querySelector('[data-zoom]');
      if (zoom) zoom.addEventListener('click', function (e) { e.stopPropagation(); self.openLightbox(); });
      if (stage) stage.addEventListener('click', function () { self.openLightbox(); });
    }

    // Flechas: avanzan por la lista navegable, no por todos los slides (si no,
    // saltarían a la foto de otra variante).
    _step(delta) {
      var nav = this._navIndexes();
      if (!nav.length) return;
      var at = nav.indexOf(this.idx);
      if (at === -1) at = 0;
      this.show(nav[(at + delta + nav.length) % nav.length]);
    }

    // Fija la imagen i (commit): persiste como imagen por defecto. La usan el
    // click en thumb, las flechas y el onClose del lightbox.
    show(i) {
      this.idx = i;
      this._display(i);
    }

    // Muestra visualmente la imagen i (escaparate + thumb activa) SIN fijarla.
    // El hover-preview la usa; al salir de los thumbs se revierte a this.idx.
    _display(i) {
      this.slides.forEach(function (s, n) { s.hidden = n !== i; });
      this.thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(parseInt(t.getAttribute('data-index'), 10) === i));
      });
    }

    openLightbox() {
      if (!this.lightbox || typeof this.lightbox.open !== 'function') return;
      var self = this;
      var pick = function (n) {
        var im = self.slides[n].querySelector('img');
        return { src: im ? (im.currentSrc || im.src) : '', alt: im ? im.alt : '' };
      };
      var nav = this._navIndexes();
      var at = nav.indexOf(this.idx);
      if (at === -1) {
        // El slide actual no es navegable (no debería pasar): abrir sólo él.
        this.lightbox.onClose = null;
        this.lightbox.open([pick(this.idx)], 0);
        return;
      }
      // Al cerrar, deja el escaparate en la última imagen vista en el lightbox.
      this.lightbox.onClose = function (i) { self.show(nav[i] !== undefined ? nav[i] : self.idx); };
      this.lightbox.open(nav.map(pick), at);
    }
  });
})();
